// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background: #f3f4f6;
  color: #1a1a1a;
  line-height: 1.5;
}

.app {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1 1;
  min-height: 100vh;
  background: #f3f4f6;
}

.loading-screen {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f3f4f6;
}

.loading-spinner {
  padding: 1.5rem 2rem;
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  color: #2563eb;
  font-weight: 500;
}

button {
  font-family: inherit;
}

input {
  font-family: inherit;
}

/* Scrollbar Styles */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.sidebar {
  background: #367CFF;
  color: white;
}

a {
  color: white;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.header {
  background: white;
  color: #333;
}

.unauthorized-page {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f3f4f6;
  padding: 2rem;
}

.unauthorized-content {
  text-align: center;
  background: white;
  padding: 3rem;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
}

.unauthorized-content h1 {
  color: #1a1a1a;
  margin-bottom: 1rem;
  font-size: 2rem;
}

.unauthorized-content p {
  color: #6b7280;
  margin-bottom: 2rem;
}

.back-btn {
  padding: 0.75rem 1.5rem;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 0.875rem;
  transition: background-color 0.2s;
}

.back-btn:hover {
  background: #1d4ed8;
}

.badge-filter {
  background: #1d4ed8;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  color: white;
}

/* Responsive Styles */
/* @media screen and (max-width: 768px) {
  .app {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
    position: fixed;
    bottom: 0;
    z-index: 1000;
    height: auto;
    padding: 0.5rem;
  }

  .sidebar nav {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .sidebar a {
    padding: 0.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 0.75rem;
  }

  .sidebar a svg {
    margin-bottom: 0.25rem;
    font-size: 1.25rem;
  }

  .main-content {
    margin-bottom: 4rem;
  }

  .header {
    position: sticky;
    top: 0;
    z-index: 900;
    padding: 0.75rem 1rem;
  }
}

@media screen and (max-width: 480px) {
  .unauthorized-content {
    padding: 2rem 1rem;
  }

  .unauthorized-content h1 {
    font-size: 1.5rem;
  }

  .back-btn {
    width: 100%;
  }
} */`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uGAAuG;EACvG,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,wCAAwC;EACxC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA,sBAAsB;AACtB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAyDG","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  background: #f3f4f6;\n  color: #1a1a1a;\n  line-height: 1.5;\n}\n\n.app {\n  display: flex;\n  min-height: 100vh;\n}\n\n.main-content {\n  flex: 1;\n  min-height: 100vh;\n  background: #f3f4f6;\n}\n\n.loading-screen {\n  min-height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #f3f4f6;\n}\n\n.loading-spinner {\n  padding: 1.5rem 2rem;\n  background: white;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  color: #2563eb;\n  font-weight: 500;\n}\n\nbutton {\n  font-family: inherit;\n}\n\ninput {\n  font-family: inherit;\n}\n\n/* Scrollbar Styles */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.sidebar {\n  background: #367CFF;\n  color: white;\n}\n\na {\n  color: white;\n  text-decoration: none;\n}\n\na:hover {\n  text-decoration: underline;\n}\n\n.header {\n  background: white;\n  color: #333;\n}\n\n.unauthorized-page {\n  min-height: 100vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #f3f4f6;\n  padding: 2rem;\n}\n\n.unauthorized-content {\n  text-align: center;\n  background: white;\n  padding: 3rem;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  max-width: 400px;\n  width: 100%;\n}\n\n.unauthorized-content h1 {\n  color: #1a1a1a;\n  margin-bottom: 1rem;\n  font-size: 2rem;\n}\n\n.unauthorized-content p {\n  color: #6b7280;\n  margin-bottom: 2rem;\n}\n\n.back-btn {\n  padding: 0.75rem 1.5rem;\n  background: #2563eb;\n  color: white;\n  border: none;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  font-size: 0.875rem;\n  transition: background-color 0.2s;\n}\n\n.back-btn:hover {\n  background: #1d4ed8;\n}\n\n.badge-filter {\n  background: #1d4ed8;\n  padding: 0.25rem 0.5rem;\n  border-radius: 0.25rem;\n  font-size: 0.75rem;\n  color: white;\n}\n\n/* Responsive Styles */\n/* @media screen and (max-width: 768px) {\n  .app {\n    flex-direction: column;\n  }\n\n  .sidebar {\n    width: 100%;\n    position: fixed;\n    bottom: 0;\n    z-index: 1000;\n    height: auto;\n    padding: 0.5rem;\n  }\n\n  .sidebar nav {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n  }\n\n  .sidebar a {\n    padding: 0.5rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: 0.75rem;\n  }\n\n  .sidebar a svg {\n    margin-bottom: 0.25rem;\n    font-size: 1.25rem;\n  }\n\n  .main-content {\n    margin-bottom: 4rem;\n  }\n\n  .header {\n    position: sticky;\n    top: 0;\n    z-index: 900;\n    padding: 0.75rem 1rem;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .unauthorized-content {\n    padding: 2rem 1rem;\n  }\n\n  .unauthorized-content h1 {\n    font-size: 1.5rem;\n  }\n\n  .back-btn {\n    width: 100%;\n  }\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
